module.exports = __webpack_public_path__ + "static/media/low_visibility_2.28e330e5.png";